// extracted by mini-css-extract-plugin
export default {"rating":"BR-z","numberOfStars":"CR-z","count":"DR-z","barGraphSpacing":"ER-z","barGraph":"FR-z"};